import { useState } from 'react';
import { useLocation, useHistory } from 'react-router';
import qs from 'qs';
import omit from 'lodash/omit';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

const getCurrentParams = (search) => {
  if (!search && typeof window === 'undefined') {
    return {};
  }
  return qs.parse(search || window.location.search, { ignoreQueryPrefix: true });
};

export default () => {
  const history = useHistory();
  const { search, pathname } = useLocation();
  const [ params, setParams ] = useState(getCurrentParams(search));

  const setSearch = (newParams) => {
    setParams(newParams);

    const search = qs.stringify(newParams, { addQueryPrefix: true });
    history.push(`${pathname}${search}`);
  };

  const removeParams = (paramKeys) => {
    const currentParams = getCurrentParams();
    const newParams = omit(currentParams, paramKeys);

    setSearch(newParams);
  };

  const buildQueryParams = (newParams, includePrevParams = true) => {
    let updatedParams = omitBy(newParams, isNil);
    if (includePrevParams) {
      updatedParams = { ...updatedParams, ...params };
    }

    return qs.stringify(updatedParams, { addQueryPrefix: true });
  };

  return {
    params,
    buildQueryParams,
    setParam: (key, value = '') => {
      const currentParams = getCurrentParams();
      const newParams = {
        ...currentParams,
        [key]: value,
      };

      setSearch(newParams);
    },
    removeParams,
    removeParam: (key) => {
      removeParams([key]);
    },
  };
};
